export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14903.e4c856c8.jpg";